import { render, staticRenderFns } from "./ComplianceRequirement.vue?vue&type=template&id=415a8eb6&scoped=true&lang=html&"
import script from "./ComplianceRequirement.vue?vue&type=script&lang=js&"
export * from "./ComplianceRequirement.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceRequirement.vue?vue&type=style&index=0&id=415a8eb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415a8eb6",
  null
  
)

export default component.exports